import { render } from "./UserNotificationsTable.vue?vue&type=template&id=15a36aea&ts=true"
import script from "./UserNotificationsTable.vue?vue&type=script&lang=ts"
export * from "./UserNotificationsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__